
const currencySymbolLookUp = {
  USD: "$",
  EUR: "€",
  JPY: "¥",
  INR: "₹",
  CNY: "CN¥",
  RMB: "CN¥",
  HKD: "HK$",
  AUD: "A$",
  KRW: "₩",
  CHF: "CHF",
  SEK: "SEK",
  DKK: "DKK",
  NOK: "NOK",
  SAR: "SAR",
  TWD: "NT$",
  GBP: "£",
  GBp: "p",
  PERC: "%",
  NONE: "",
};

function getCurrencySymbol(value) {
  if (!value) return "";
  return currencySymbolLookUp[value] || currencySymbolLookUp[value.toUpperCase()] || value;
}

export {
  getCurrencySymbol,
};